<template>
  <section class="hero">
    <div class="hero-body">
      <div class="container">
        <h1 class="title">Serie viste</h1>

        <b-tabs v-model="selectedTab">
          <b-modal :active.sync="showSeriesDetails" :width="800">
            <series-details
              :series-data="seriesDetails"
              @SeriesDetailsDelete="doDelete"
              @SeriesDetailsEdit="doEdit"
              @SeriesDetailsNewSeason="doNewSeason"
            />
          </b-modal>
          <b-tab-item label="Visioni">
            <div style="cursor: pointer">
              <b-table
                :data="rowData"
                :columns="columns"
                :striped="true"
                :paginated="true"
                :per-page="10"
                :total="total"
                :hoverable="true"
                :current-page.sync="page"
                :pagination-simple="false"
                :selected.sync="selected"
                :backend-pagination="true"
                :backend-filtering="true"
                @filters-change="filtersChange"
                @select="select"
                @click="rowClicked"
                @page-change="onPageChange"
              >
                <b-input
                  slot="searchable"
                  slot-scope="props"
                  v-model="props.filters[props.column.field]"
                  placeholder="Cerca..."
                  icon="magnify"
                  size="is-small"
                />
              </b-table>
            </div>
            <section>
              <div class="buttons">
                <b-button @click="doNew" type="is-primary">Nuovo</b-button>
                <b-button @click="doClearSearch" type="is-primary"
                  >Mastrolindo</b-button
                >
              </div>
            </section>
          </b-tab-item>

          <b-tab-item :disabled="false" label="Dettagli">
            <h1 class="title">
             {{vSeries.SeriesFullTitle}}
            </h1>
            <h1 class="is-size-4">Serie</h1>
            <div class="columns">
              <div class="column is-half">
                <b-field label="Titolo">
                  <b-input
                    ref="iTitolo"
                    v-model="vSeries.Series.Title"
                    required
                    validation-message="Obbligatorio!"
                    tabindex="1"
                  ></b-input>
                </b-field>

                <b-field label="Anno Inizio">
                  <b-input
                    ref="iAnnoInizio"
                    v-model="vSeries.Series.YearBegin"
                    type="number"
                    min="1800"
                    max="2100"
                    required
                    validation-message="Mettici un numero buono!"
                    tabindex="3"
                  ></b-input>
                </b-field>

                <b-field label="Stato serie">
                  <b-select
                    ref="iSeriesStatus"
                    v-model="vSeries.Series.StatusId"
                    required
                    validation-message="Obbligatorio!"
                  >
                    <option
                      v-for="x in lovs.seriesStatusForSeries"
                      :value="x.Id"
                      :key="x.Id"
                    >
                      {{ x.SeriesStatus }}
                    </option>
                  </b-select>
                </b-field>

               
              </div>

              <div class="column">
                <b-field label="Titolo originale">
                  <b-input
                    ref="iTitoloOr"
                    v-model="vSeries.Series.OriginalTitle"
                    required
                    validation-message="Obbligatorio!"
                    tabindex="2"
                  ></b-input>
                </b-field>
                <b-field label="Anno Fine">
                  <b-input
                    ref="iAnnoFine"
                    v-model="vSeries.Series.YearEnd"
                    required
                    type="number"
                    min="1800"
                    max="2100"
                    validation-message="Mettici un numero buono!"
                    tabindex="4"
                  ></b-input>
                </b-field>
              
              </div>
            </div>
            <div>
              <h1 class="is-size-4">Stagione</h1>
              <div class="columns">
                <div class="column">
                  <b-field label="Numero stagione">
                    <b-input
                      ref="iNumber"
                      v-model="vSeries.Number"
                      type="number"
                      required
                      validation-message="Obbligatorio!"
                      tabindex="1"
                    ></b-input>
                  </b-field>
                  <b-field label="Data Inizio Visione">
                    <b-datepicker
                      ref="iDateBegin"
                      v-model="vSeries.DateBeginDate"
                      editable
                      :date-formatter="isoDate"
                      required
                      validation-message="Obbligatorio!"
                    >
                    </b-datepicker>
                  </b-field>
                   <b-field label="Stato stagione">
                  <b-select
                    ref="iSeasonStatus"
                    v-model="vSeries.StatusId"
                    required
                    validation-message="Obbligatorio!"
                  >
                    <option
                      v-for="x in lovs.seriesStatusForSeasons"
                      :value="x.Id"
                      :key="x.Id"
                    >
                      {{ x.SeriesStatus }}
                    </option>
                  </b-select>
                </b-field>
                 <b-field label="Commenti">
              <b-input  type="textarea"  v-model="vSeries.Comment"></b-input>
            </b-field>
                   <section>
                  <div class="buttons">
                    <b-button @click="doSave" type="is-primary">Vai</b-button>
                    <b-button @click="doCancel" type="is-primary"
                      >Naaah</b-button
                    >
                  </div>
                </section>
                </div>
                <div class="column">
                  <b-field label="Servizio">
                    <b-select ref="iService" v-model="vSeries.ServiceId">
                      <option
                        v-for="service in lovs.service"
                        :value="service.Id"
                        :key="service.Id"
                      >
                        {{ service.Name }}
                      </option>
                    </b-select>
                  </b-field>
                  <b-field label="Data Fine Visione">
                    <b-datepicker
                      ref="iDateEnd"
                      v-model="vSeries.DateEndDate"
                      editable
                      :date-formatter="isoDate"
                      validation-message="Obbligatorio!"
                    >
                    </b-datepicker>
                  </b-field>
                  <b-field label="Voto">
                    <star-rating
                      v-model="vSeries.Dicks"
                      :show-rating="false"
                      :increment="0.5"
                      :star-size="30"
                    />
                  </b-field>
                </div>
              </div>
            </div>
          </b-tab-item>
          <b-tab-item label="Aggiungi">
            <add-series @OkSearchImdb="doOkImdb" />
          </b-tab-item>
          <b-tab-item label="Ricerca" ref="form">
            <search-series @OkSearchSeries="doOkSearch" />
          </b-tab-item>
        </b-tabs>
      </div>
    </div>
  </section>
</template>

<script>
import api from "../api/api.js";
import helpers from "../helpers.js";

import AddSeries from "@/components/AddSeries";
import SeriesDetails from "@/components/SeriesDetails";
import StarRating from "vue-star-rating";
import SearchSeries from "@/components/SearchSeries";

let emptyVal ={Series:{}};

export default {
  name: "series",
  components: { AddSeries, StarRating, SeriesDetails, SearchSeries },
  methods: {
    filtersChange(filter) {
      this.filter=filter;
      this.getData();
      this.getTotal();
    },
    flattenSeasons(data) {
      let out = [];
      data.forEach((el) => {
        let statusName = helpers.lookupLOV(
          this.lovs,
          "seriesStatus",
          el.StatusId,
          "SeriesStatus"
        );
        let seriesStatusName = helpers.lookupLOV(
          this.lovs,
          "seriesStatus",
          el.Series.StatusId,
          "SeriesStatus"
        );
        out.push({
          ...el,
          SeriesFullTitle: `${el.Series.Title} (${el.Series.OriginalTitle}, ${el.Series.YearBegin}-${el.Series.YearEnd})`,
          Status: statusName,
          SeriesStatus: seriesStatusName,
          DateBeginDate: this.isoDate(el.DateBegin*1000),
          DateEndDate: this.isoDate(el.DateEnd*1000)
        });
      });

      return out;
    },
    getData() {
      const loading = this.$buefy.loading.open();
      api.series
        .getPaginated(
          (this.page - 1) * 10,
          10,
          helpers.buildSeriesFilter(this.filter, this.lovs)
        )
        .then((rows) => {
          this.buildActiveLovs();
          this.rowData = this.flattenSeasons(rows.data);
          loading.close();
        })
        .catch((err) => {
          helpers.error("Errore! " + err);
          loading.close();
        });
    },

    buildActiveLovs() {
      if (this.$store.state.languages == null) {
        console.warn("Dovrei fare qualcosa!");
      }
      this.lovs.seriesStatus = this.$store.state.seriesStatuses.filter((x) => {
        return x.Active;
      });
       this.lovs.service = this.$store.state.services.filter((x) => {
        return x.Active && x.Is_tv;
      });
      this.lovs.seriesStatusForSeries = this.lovs.seriesStatus.filter(
        (x) => !x.IsSeason
      );
       this.lovs.seriesStatusForSeasons = this.lovs.seriesStatus.filter(
        (x) => x.IsSeason
      );
    },
    getTotal() {
      const loading = this.$buefy.loading.open();
      api.series.getTotal(helpers.buildSeriesFilter(this.filter, this.lovs).Clauses).then((rows) => {
        this.total = rows.data;
        loading.close();
      }).catch((err) => {
          helpers.error("Errore! " + err);
          loading.close();
        });
    },

    isoDate(date) {
      if (date)  return helpers.buildIsoDate(date)
      else return null;
    },
    doDelete() {
      this.$buefy.dialog.confirm({
        message: "Scancello sul serio? Se è l'ultima stagione, scancellerò anche la serie relativa",
        onConfirm: () => {
          const loading = this.$buefy.loading.open();
          api.series
            .delete(this.seriesDetails.row.Id)
            .then(() => {
              this.getData();
              this.getTotal();
              helpers.ok("Serie correttamente scancellata");
              this.vSeries = emptyVal;
              this.showSeriesDetails = false;
              loading.close();
            })
            .catch((err) => {
              helpers.error("Errore! " + err);
              loading.close();
            });
        },
      });
    },
    doOkImdb(imdbData) {
      this.vSeries = imdbData;
      this.selectedTab = 1;
    },
    doCancel() {
      this.vSeries.DateBeginDate=this.isoDate(this.vSeries.DateBegin*1000);
      this.vSeries.DateBeginEnd=this.isoDate(this.vSeries.DateEnd*1000);
      this.vSeries = emptyVal;
      this.selectedTab = 0;
    },
    doOkSearch(filterModel) {
      this.filter = filterModel;
      this.selectedTab = 0;
      this.getData();
      this.getTotal();
    },
    doClearSearch() {
      this.doOkSearch({});
    },
    doNew() {
      this.selectedTab = 2;
    },
    doSave() {
      if (
        !this.$refs["iTitolo"].checkHtml5Validity() ||
        !this.$refs["iTitoloOr"].checkHtml5Validity() ||
        !this.$refs["iAnnoInizio"].checkHtml5Validity() ||
        !this.$refs["iAnnoFine"].checkHtml5Validity() ||
        !this.$refs["iSeriesStatus"].checkHtml5Validity() ||
        !this.$refs["iSeasonStatus"].checkHtml5Validity() ||
        !this.$refs["iNumber"].checkHtml5Validity() ||
        !this.$refs["iDateBegin"].checkHtml5Validity() ||
        !this.$refs["iDateEnd"].checkHtml5Validity() ||
        !this.$refs["iService"].checkHtml5Validity()
      ) {
        helpers.error("C'è qualcosa che non va nelle validazioni!");
        return;
      }
     
      let apiMethod = this.vSeries.Id ? api.series.update : api.series.create;

      const loading = this.$buefy.loading.open();
      apiMethod(this.vSeries)
        .then(() => {
          this.getData();
          this.getTotal();
          this.vSeries = emptyVal;
          this.selectedTab = 0;
          loading.close();
        })
        .catch((err) => {
          helpers.error("Errore! " + err);
          loading.close();
        });
    },
    doEdit() {
      this.vSeries = this.seriesDetails.row;
      this.vSeries.DateBeginDate = new Date(this.vSeries.DateBegin*1000);
      if (this.vSeries.DateEndDate) 
        this.vSeries.DateEndDate = new Date(this.vSeries.DateEnd*1000);
      this.showSeriesDetails = false;
      this.buildActiveLovs();
      this.selectedTab = 1;
    },
     doNewSeason() {
      this.vSeries = this.seriesDetails.row;
       this.vSeries.Id = 0;
      this.vSeries.Number=null;
      this.vSeries.DateBeginDate = null;
      this.vSeries.StatusId=null;
      this.vSeries.ServiceId=null;
      this.vSeries.DateEndDate=null;
      this.vSeries.Dicks=null;
      this.vSeries.Comment=null;
      this.showSeriesDetails = false;
      this.buildActiveLovs();
      this.selectedTab = 1;
    },
    rowClicked(row) {
      const loading = this.$buefy.loading.open();
       api.tmdb
         .getSeries(row.Series.TmdbId)
         .then((series) => {
           this.seriesDetails = { row: row, tmdb: series.data };
           this.seriesDetails.genre_string = series.data.genres
            .map((x) => x.name)
            .join("/");
           this.seriesDetails.created_by = series.data.created_by.map((x) => x.name)
            .join(", ");
          this.showSeriesDetails = true;
          loading.close();
        })
     
    },
    select(row) {
      this.newItem = row;
      this.selected = row;
    },
    onPageChange(page) {
      this.page = page;
      this.getData();
    },
  },
  data() {
    return {
      selectedRow: null,
      newItem: emptyVal,
      vSeries: emptyVal,
      rowData: [],
      mRowData: [],
      imdbData: [],
      selected: null,
      lovs: {},
      selectedTab: 0,
      imdbName: "",
      page: 1,
      perPage: 10,
      total: 0,
      filter: {},
      showSeriesDetails: false,
      seriesDetails: { row: {}, tmdb: {} },
      filteredTags: [],
      columns: [
        {
          field: "Id",
          label: "Id",
          width: "40",
          numeric: true,
        },
        {
          field: "SeriesFullTitle",
          label: "Serie",
          searchable: true
        },
        {
          field: "Number",
          label: "Season",
          width: "120px",
          searchable: true
        },
        {
          field: "DateBeginDate",
          label: "Iniziata il",
          width: "120px",
          searchable: true
        },
        {
          field: "DateEndDate",
          label: "Finita il",
          width: "120px",
          searchable: true
        },
        {
          field: "Status",
          label: "Stato stagione",
          searchable: true
        },
        {
          field: "Dicks",
          label: "Voto",
          searchable: true
        },
        {
          field: "SeriesStatus",
          label: "Stato serie",
          searchable: true
        },
      ],
    };
  },
  mounted() {
    // if (this.$store.state.jumpId) {
    //   this.filter = {
    //     Id: this.$store.state.jumpId
    //   }
    //   this.$store.state.jumpId = null;
    // }
    const loading = this.$buefy.loading.open();
    if (this.$store.state.seriesStatuses == null) {
      api.lovs().then((data) => {
        this.$store.state.languages = data.data.languages;
        this.$store.state.cities = data.data.cities;
        this.$store.state.friends = data.data.friends;
        this.$store.state.modes = data.data.modes;
        this.$store.state.services = data.data.services;
        this.$store.state.seriesStatuses = data.data.seriesStatuses;

        this.getTotal();
        this.getData();
        loading.close();
      });
    } else {
      this.getTotal();
      this.getData();
      loading.close();
    }
  },
};
</script>

<style>
</style>
